import React from "react";
import vecChannel from "../../../../../../../Assets/Images/ChannelVector.png";
import { useFormik } from "formik";
import * as Yup from "yup";
export default function CreateChannel({
  setCreateNewChannelSection,
  newChannel,
  setNewChannel,
}) {
  return (
    <div className="p-4">
      <div className="mb-6">
        {/* Image Placeholder */}
        <div className="flex mx-auto justify-center mb-8">
          <img src={vecChannel} alt={vecChannel} />
        </div>

        {/* Explanation Section */}
        <h2 className="text-xl text-center font-semibold mb-2">
          What is a channel?
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Channels are a one-to-many tool for broadcasting your messages to
          unlimited audiences.
        </p>
      </div>

      {/* Create Channel Form */}
      <div>
        <button
          onClick={() => setCreateNewChannelSection(2)} // ✅ Toggle here
          className="btn btn-default bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0 flex justify-center mx-auto"
        >
          Create Channel
        </button>
      </div>
    </div>
  );
}
